import { useGetKanbanOrders, useUpdateOrderStatus } from '../../../api/orderApi';
import type { OrderItem } from '../../../types';
import { ORDER_STATUSES } from '../constants';

export interface KanbanColumn {
  status: string;
  orders: OrderItem[];
}

export function useKanbanOrders() {
  const { data: orders, isLoading, error, refetch } = useGetKanbanOrders();
  const updateOrderStatus = useUpdateOrderStatus();

  const columns = ORDER_STATUSES.map(status => ({
    status,
    orders: orders?.filter(o => o.orderStatus === status) || []
  }));

  const moveOrder = async (orderId: string, newStatus: string) => {
    await updateOrderStatus.mutateAsync({ id: orderId, status: newStatus });
  };

  return { 
    columns, 
    loading: isLoading, 
    error: error?.message || null, 
    refresh: refetch, 
    moveOrder 
  };
}
